import React from 'react'
import "./Back_text_holder.css"
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'

function Back_text_holder({ baseLink, backText }) {
    return (
        <>
            <section className='Back_text_holder'>
                <div className="container">
                    <Link to={baseLink}>
                        <h6 className='heading_text'><FontAwesomeIcon className='me-2' icon={faArrowLeft} /> Back to {backText}</h6>
                    </Link>
                </div>
            </section>

        </>
    )
}

export default Back_text_holder
